import {NgModule} from '@angular/core';
import {AgGridModule} from 'ag-grid-angular';
import {DispoDetailsComponent} from './dispo-details.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';


@NgModule({
  declarations: [DispoDetailsComponent],
    imports: [
        CollapseModule,
        AgGridModule,
        FontAwesomeModule
    ],
  exports: [DispoDetailsComponent]
})
export class DispoDetailsModule {
}
